module.exports = __webpack_public_path__ + "img/button-doctorsearch_TC.6cfb29dc.png";